import { supabase } from './supabase';

export const uploadProfilePicture = async (file: File, accountId: string): Promise<string> => {
  const fileExt = file.name.split('.').pop();
  const filePath = `${accountId}/profile.${fileExt}`;

  const { error } = await supabase.storage
    .from('scenechat-assets')
    .upload(filePath, file, { upsert: true });

  if (error) throw error;

  const { data } = supabase.storage
    .from('scenechat-assets')
    .getPublicUrl(filePath);

  return data.publicUrl;
};

export const deleteProfilePicture = async (accountId: string, fileExt: string): Promise<void> => {
  const filePath = `${accountId}/profile.${fileExt}`;
  await supabase.storage.from('scenechat-assets').remove([filePath]);
};

export const uploadQRCode = async (file: File, accountId: string): Promise<string> => {
  const fileExt = file.name.split('.').pop();
  const filePath = `${accountId}/qr-code.${fileExt}`;

  const { error } = await supabase.storage
    .from('scenechat-assets')
    .upload(filePath, file, { upsert: true });

  if (error) throw error;

  const { data } = supabase.storage
    .from('scenechat-assets')
    .getPublicUrl(filePath);

  return data.publicUrl;
};
